const Logo = () => {
    return (
        <span style={{float: "left", height: "50px"}}>
            <img src="images/workmanship-logo.png" alt="logo" width="200" height="50"></img>
        </span>
    )
}

export default Logo;